module.exports = __webpack_public_path__ + "img/wukemu.3f04c736.png";